import { useBranding } from "@/hooks/useBranding";
import { useTheme } from "next-themes";
import logoDark from "@/assets/acex-logo-dark.svg";
import logoLight from "@/assets/acex-logo-light.svg";

const DEFAULT_PATHS = new Set([
  "/acex-logo-dark.png",
  "/acex-logo-light.png",
  "/acex-favicon.png",
]);

const isDefaultLogo = (url?: string) => !url || DEFAULT_PATHS.has(url);

interface BrandLogoProps {
  className?: string;
}

export default function BrandLogo({ className = "max-w-[180px] object-contain" }: BrandLogoProps) {
  const { appName, logoUrl, logoLightUrl } = useBranding();
  const { resolvedTheme } = useTheme();
  const isDark = resolvedTheme === "dark";

  const hasCustomLogo = !isDefaultLogo(logoUrl) || !isDefaultLogo(logoLightUrl);
  const fallbackSrc = isDark ? logoDark : logoLight;
  const src = hasCustomLogo
    ? (isDark ? logoUrl || logoLightUrl : logoLightUrl || logoUrl)
    : fallbackSrc;

  return <img src={src} alt={appName} className={className} />;
}
